import React from 'react';
import {createRoot} from 'react-dom/client';

import BaseComponent from '../../common/BaseComponent/BaseComponent';
import ComponentFooter from '../../components/ComponentFooter/ComponentFooter';
import ComponentHeaderPublic from '../../components/ComponentHeaderPublic/ComponentHeaderPublic';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";

import styles from './PageDomainsAll.scss';

import ComponentSearchDomainForm from "../../components/ComponentSearchDomainForm/ComponentSearchDomainForm";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import {ContextServicePrice, ContextServicePriceProvider} from '../../context/ContextServicePriceProvider';
import {ContextTLD, ContextTLDProvider} from "../../context/ContextTLDProvider";
import ComponentTLDTable from "../../components/ComponentTLDTable/ComponentTLDTable";
import ComponentTransferDomainBlock from "../../components/ComponentTransferDomainBlock/ComponentTransferDomainBlock";
import DomainAdditionalInfo from "./DomainAdditionalInfo";
import {_isMobile} from "../../common/helpers/HelperFunc";
import {__t} from '../../common/lang/text-resource';

class PageDomainsAll extends BaseComponent {

	constructor() {
		super(...arguments, 'PageDomainsAll ');
		SHVO.pageComponent = this;
	}

	additionalInfoRef = React.createRef();
	transferBlockRef = React.createRef();
	state = {
		isMobile: _isMobile(),
		tableIsMobile: window.innerWidth < 500
	};

	scrollToAdditionalInfo = () => {
		window.scrollTo(0, this.additionalInfoRef.current.offsetTop - 80);
	};

	scrollToTransferBlock = () => {
		window.scrollTo(0, this.transferBlockRef.current.offsetTop - 80);
	};

	componentDidMount() {
		window.addEventListener('resize', this.toggleColumns);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.toggleColumns);
	}

	toggleColumns = () => {
		const isMobile = _isMobile();
		const tableIsMobile = window.innerWidth < 500;
		if (this.state.isMobile !== isMobile || this.state.tableIsMobile !== tableIsMobile) {
			this.setState({isMobile: isMobile, tableIsMobile: tableIsMobile})
		}
	};

	render() {
		const cTransfer = this.props.data.componentData.transferBlock;
		const header = this.props.data.componentData.header;

		return (
		  <div>
			  <ComponentHeaderPublic data={header} isLazy={'1'}/>
			  <ContextTLDProvider>
				  <header className={`${styles.header}`}>
					  <div className={styles.inner} data-layout='text-center'>
						  <h1><label htmlFor="domainName">{__t('Домейни')}</label></h1>

						  <ComponentSearchDomainForm
							isTransparent={true}
							placeholder='mysupersite.net'
							animationPlaceholders={["mysupersite.com", "mysupersite.bg", "mysupersite.eu", "mysupersite.net"]}/>

						  <div className={styles.additionalInfo} data-layout='row gutter-none start text-left'>
							  <div data-layout='col 12 6@md'>
								  {__t('изберете-атрактивно-и-запомнящо-се-име-за-вашия-у94a96b')}&nbsp;
								  <Button
									onClick={this.scrollToAdditionalInfo}
									name='go_to_additional_info'
									value={__t('Научете как!')}
									className={`${buttons.buttonLink} ${buttons.action}`}/>
							  </div>
							  <div data-layout='col 12 6@md'>
								  {__t('ако-вече-имате-домейн-прехвърлете-го-при-нас-бързa4ee8b')}&nbsp;
								  <Button
									onClick={this.scrollToTransferBlock}
									name='go_to_transfer'
									value={__t('Научете повече!')}
									className={`${buttons.buttonLink} ${buttons.action}`}/>
							  </div>
						  </div>
					  </div>
				  </header>

				  <ContextServicePriceProvider>

					  <ContextServicePrice.Consumer>
						  {
							  (prices) => {
								  return (
									<ContextTLD.Consumer>
										{(tlds) => {

											const allTLDS = tlds.getAllTLDs();
											const allTLDCategories = tlds.getAllTLDCategories();
											const allTags = tlds.getAllTags();
											const promotions = tlds.getPromotions();
											let defaultTag = tlds.getDefaultTag();
											const pricesAll = prices.contextData.prices;
											let finalData = {};
											allTLDS.map((tld, key) => {
												if ('undefined' !== typeof pricesAll[tld.id])
												{
													const tldTMP = {
														...tld,
														prices: {...pricesAll[tld.id]},
														transferPrices: {...pricesAll[tld.transfer_id]}
													};

													finalData[tld.category_id] = {
														...finalData[tld.category_id],
														[key]: tldTMP
													};

													finalData['all'] = {
														...finalData['all'],
														[tldTMP.id]: tldTMP
													}
												}
											});

											finalData['all'] = Object.values(finalData['all']);

											let hashCategory = null;
											const hash = window.location.hash.replace('#', '');

											let categoriesFormatted = Object.keys(allTLDCategories).map((key) => {
												const objTMP = {
													value: allTLDCategories[key].id,
													label: allTLDCategories[key].name,
													anchor: allTLDCategories[key].anchor
												};
												if (typeof hash !== 'undefined' && hash !== '' && hash === allTLDCategories[key].anchor) {
													hashCategory = objTMP;
												}
												return objTMP;
											});
											const allOBJ = {
												value: 'all',
												label: __t('всички'),
												anchor: 'all_domains'
											};
											categoriesFormatted = [...categoriesFormatted, allOBJ];
											if (typeof hash !== 'undefined' && hash !== '' && hash === allOBJ.anchor) {
												hashCategory = allOBJ;
											}

											let defaultCategory = hashCategory ? hashCategory : categoriesFormatted[0];

											if (!hashCategory && typeof hash !== 'undefined' && hash !== '') {
												allTags.map((tag) => {
													if (tag.anchor === hash) {
														defaultCategory = categoriesFormatted.filter((category) => category.anchor === 'new-domains')[0];
														defaultTag = tag;
													}
												});
											}
											return <ComponentTLDTable
											  tldData={finalData}
											  categories={categoriesFormatted}
											  defaultCategory={defaultCategory}
											  allTags={allTags}
											  promotions={promotions}
											  defaultTag={defaultTag}
											  isMobile={this.state.tableIsMobile}/>

										}}
									</ContextTLD.Consumer>

								  )
							  }

						  }
					  </ContextServicePrice.Consumer>

				  </ContextServicePriceProvider>

				  <section data-layout="padding-left--smm padding-right--smm" className={styles.transferContainer}
						   ref={this.transferBlockRef}>
					  <h1>{__t('Прехвърляне (трансфер) на домейн')}</h1>
					  <ComponentTransferDomainBlock isMobile={this.state.isMobile} data={cTransfer}/>
				  </section>

				  <section data-layout="padding-left--smm padding-right--smm" className={styles.domainAdditionalInfo}
						   ref={this.additionalInfoRef}>
					  <h1>{__t('Помощна информация-help')}</h1>
					  <DomainAdditionalInfo data={{}} isMobile={this.state.isMobile}/>
				  </section>
			  </ContextTLDProvider>
			  <section className={styles.moreInfo}>
				  {__t('научете-повече-за-домейните-и-управлението-на-ваш053a01')}{' '}
				  {SHVO.pageLang == 'en' ?
					<a href="https://help.superhosting.bg/en">help.superhosting.bg</a>
					:
					<a href="https://help.superhosting.bg/">help.superhosting.bg</a>}
			  </section>
			  <ComponentFooter data={{}}/>
		  </div>
		);
	}
}

PageDomainsAll.contextType = ContextDataStore;
const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageDomainsAll data={SHVO.pageState}/>);